/* ============================================================
   El Workshop — Professional "project / quote" store
   Client-side (localStorage) list a professional builds for a client,
   then exports as a branded PDF. No backend required.
   Exposed as window.EWProject.
   ============================================================ */
(function () {
  var KEY = 'ew_project_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return { items: [], client: '', project: '', notes: '', discount: 0 };
      var d = JSON.parse(raw);
      if (!d || !Array.isArray(d.items)) return { items: [], client: '', project: '', notes: '', discount: 0 };
      return d;
    } catch (e) {
      return { items: [], client: '', project: '', notes: '', discount: 0 };
    }
  }

  function write(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
    updateBadges();
    document.dispatchEvent(new CustomEvent('ew-project:change', { detail: d }));
  }

  function count() {
    return read().items.reduce(function (n, it) { return n + (parseInt(it.qty, 10) || 1); }, 0);
  }

  function updateBadges() {
    var c = count();
    document.querySelectorAll('[data-ew-project-count]').forEach(function (el) {
      el.textContent = c;
      el.style.display = c > 0 ? '' : 'none';
    });
  }

  function add(item) {
    var d = read();
    var existing = d.items.filter(function (x) { return x.id === item.id; })[0];
    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 1) + (parseInt(item.qty, 10) || 1);
    } else {
      d.items.push({
        id: item.id,
        title: item.title || '',
        ref: item.ref || '',
        price: parseInt(item.price, 10) || 0, // cents
        priceStr: item.priceStr || '',
        image: item.image || '',
        url: item.url || '',
        qty: parseInt(item.qty, 10) || 1
      });
    }
    write(d);
    return d;
  }

  function remove(id) {
    var d = read();
    d.items = d.items.filter(function (x) { return x.id !== id; });
    write(d);
    return d;
  }

  function setQty(id, qty) {
    var d = read();
    d.items.forEach(function (x) { if (x.id === id) { x.qty = Math.max(1, parseInt(qty, 10) || 1); } });
    write(d);
    return d;
  }

  function setMeta(patch) {
    var d = read();
    Object.assign(d, patch);
    write(d);
    return d;
  }

  function clear() {
    write({ items: [], client: '', project: '', notes: '', discount: 0 });
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'ew-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  }

  // Delegate clicks on any "add to project" button on the page.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-project]');
    if (!btn) return;
    e.preventDefault();
    add({
      id: btn.getAttribute('data-id'),
      title: btn.getAttribute('data-title'),
      ref: btn.getAttribute('data-ref'),
      price: btn.getAttribute('data-price'),
      priceStr: btn.getAttribute('data-price-str'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url'),
      qty: 1
    });
    btn.classList.add('is-added');
    var addedLabel = btn.getAttribute('data-added-label');
    if (addedLabel) {
      var span = btn.querySelector('[data-add-label]');
      if (span) span.textContent = addedLabel;
    }
    toast(btn.getAttribute('data-toast') || 'Added to project');
  });

  window.EWProject = { read: read, add: add, remove: remove, setQty: setQty, setMeta: setMeta, clear: clear, count: count, updateBadges: updateBadges };

  document.addEventListener('DOMContentLoaded', updateBadges);
  updateBadges();
})();
